/* koala-price-sync v3.8 — auto-preselect popular tier + theme-aware OLD/NEW reveal */
(function () {
  'use strict';

  var DEBUG = false;
  try {
    DEBUG = /[?&]koala_price_debug=1\b/.test(window.location.search);
  } catch (e) {}

  function debug() {
    if (!DEBUG) return;
    try { console.log.apply(console, ['[koala-price-sync]'].concat([].slice.call(arguments))); } catch (e) {}
  }

  function warn() {
    try { console.warn.apply(console, ['[koala-price-sync]'].concat([].slice.call(arguments))); } catch (e) {}
  }

  var DEFAULT_MONEY_FORMAT = '{{amount_no_decimals}} RON';

  function formatCents(cents, moneyFormat) {
    var fmt = moneyFormat || DEFAULT_MONEY_FORMAT;
    var n = Math.max(0, Math.round(Number(cents) || 0));
    return fmt.replace(/\{\{\s*amount[^}]*\}\}/g, function (token) {
      var inner = token.replace(/[{}]/g, '').trim().toLowerCase();
      if (inner.indexOf('no_decimals') !== -1) {
        return Math.round(n / 100).toLocaleString('ro-RO');
      }
      if (inner.indexOf('with_comma_separator') !== -1) {
        return (n / 100).toLocaleString('ro-RO', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      }
      return (n / 100).toLocaleString('ro-RO', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    });
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function decodeState(widget) {
    var raw = widget.getAttribute('data-state');
    if (!raw) return null;
    try {
      var json = atob(raw);
      try { json = decodeURIComponent(escape(json)); } catch (e) {}
      return JSON.parse(json);
    } catch (e) {
      warn('failed to decode data-state', e);
      return null;
    }
  }

  function flattenRewards(state) {
    if (!state || !state.rewards) return [];
    var out = [];
    Object.keys(state.rewards).forEach(function (k) {
      var arr = state.rewards[k];
      if (Array.isArray(arr)) out = out.concat(arr);
    });
    return out;
  }

  function pickAvailableVariant(reward) {
    if (!reward || !Array.isArray(reward.variants)) return null;
    for (var i = 0; i < reward.variants.length; i++) {
      if (reward.variants[i] && reward.variants[i].available !== false) return reward.variants[i];
    }
    return reward.variants[0] || null;
  }

  function findPriceBlock(widget) {
    var scope = widget && widget.closest ? widget.closest('.product, .product__info, form, section') : null;
    if (scope) {
      var local = scope.querySelector('[data-koala-price-block]');
      if (local) return local;
    }
    var productPrice = document.querySelector('.product__price [data-koala-price-block]');
    if (productPrice) return productPrice;
    return document.querySelector('[data-koala-price-block]');
  }

  function readMainPriceCents(block) {
    if (!block) return 0;
    var attr = block.getAttribute('data-variant-price');
    if (attr) {
      var v = parseInt(attr, 10);
      if (!isNaN(v) && v > 0) return v;
    }
    var base = block.querySelector('[data-koala-base-price]');
    if (base) {
      var digits = (base.textContent || '').replace(/[^\d]/g, '');
      if (digits) {
        var n = parseInt(digits, 10);
        if (!isNaN(n)) return n * 100;
      }
    }
    return 0;
  }

  function getOrCreateSlot(block, attrName, className) {
    var el = block.querySelector('[' + attrName + ']');
    if (el) return el;
    el = document.createElement('span');
    el.className = className;
    el.setAttribute(attrName, '');
    el.setAttribute('hidden', '');
    el.setAttribute('aria-hidden', 'true');
    block.appendChild(el);
    return el;
  }

  function showSlot(el, html) {
    if (!el) return;
    el.innerHTML = html;
    el.removeAttribute('hidden');
    el.removeAttribute('aria-hidden');
  }

  function hideSlot(el) {
    if (!el) return;
    el.innerHTML = '';
    el.setAttribute('hidden', '');
    el.setAttribute('aria-hidden', 'true');
  }

  function announce(block, msg) {
    var node = block && block.querySelector ? block.querySelector('[data-koala-announce]') : null;
    if (!node) return;
    node.textContent = '';
    setTimeout(function () { node.textContent = msg; }, 50);
  }

  // ============================================================
  // QUANTITY_BREAKS support
  // ============================================================

  function getBlockId(widget) {
    if (!widget) return null;
    // Prefer data-block-id — matches window.ProfitKoala keys (bare uuid, no prefix)
    var attr = widget.getAttribute('data-block-id') || widget.getAttribute('data-id');
    if (attr) return attr;
    if (widget.id) {
      // Strip Koala's element-id prefixes so the result keys into window.ProfitKoala
      return widget.id.replace(/^koala--embed-qb-/, '').replace(/^koala-gifts-reward-showcase-/, '');
    }
    var inner = widget.querySelector('[data-block-id], [id]');
    if (inner) return inner.getAttribute('data-block-id') || inner.id;
    return null;
  }

  function getKoalaBlockData(blockId) {
    if (!blockId) return null;
    try {
      var pk = window.ProfitKoala;
      if (!pk) return null;
      return pk[blockId] || pk[String(blockId)] || null;
    } catch (e) {
      return null;
    }
  }

  function discoverQuantityBreaksWidgets() {
    var nodes = document.querySelectorAll('koala-quantity-breaks-embed');
    var out = [];
    for (var i = 0; i < nodes.length; i++) {
      var w = nodes[i];
      var id = getBlockId(w);
      var data = getKoalaBlockData(id);
      if (!data || !data.deal || data.deal.type !== 'QUANTITY_BREAKS') continue;
      out.push({ widget: w, blockId: id, deal: data.deal, product: data.product });
    }
    return out;
  }

  function readContractIdFromEl(el) {
    if (!el) return null;
    var direct = el.getAttribute('data-tier-id')
      || el.getAttribute('data-contract-id')
      || el.getAttribute('data-id')
      || (el.dataset && (el.dataset.tierId || el.dataset.contractId || el.dataset.id));
    if (direct) return direct;
    // Koala uses className tokens: `koala-contract-{uuid}` on radio inputs, `tier-{uuid}` on tier li.
    var cls = (typeof el.className === 'string') ? el.className : (el.className && el.className.baseVal) || '';
    if (cls) {
      var m = cls.match(/(?:koala-contract|tier)-([0-9a-f]{8}-[0-9a-f-]+)/i);
      if (m) return m[1];
    }
    var v = el.getAttribute('value');
    if (v && v !== 'on' && v !== 'off') return v;
    return null;
  }

  function getSelectedTier(widget, deal) {
    if (!widget || !deal || !deal.definition || !Array.isArray(deal.definition.contracts)) return null;
    var contracts = deal.definition.contracts;

    var selectors = [
      '.koala-deal__tier--selected',
      '[aria-selected="true"]',
      'input[type="radio"]:checked',
      '[data-selected="true"]',
      '.is-selected',
      '.selected'
    ];

    var selectedEl = null;
    for (var s = 0; s < selectors.length; s++) {
      selectedEl = widget.querySelector(selectors[s]);
      if (selectedEl) break;
    }

    if (selectedEl) {
      // walk up to find a tier id
      var probe = selectedEl;
      for (var depth = 0; depth < 4 && probe; depth++) {
        var tid = readContractIdFromEl(probe);
        if (tid) {
          for (var i = 0; i < contracts.length; i++) {
            if (String(contracts[i].id) === String(tid)) return contracts[i];
          }
        }
        probe = probe.parentElement;
      }
      // fallback by minQuantity attribute
      var mq = selectedEl.getAttribute('data-min-quantity') || (selectedEl.dataset && selectedEl.dataset.minQuantity);
      if (mq) {
        var minQ = parseInt(mq, 10);
        for (var j = 0; j < contracts.length; j++) {
          if (contracts[j].minQuantity === minQ) return contracts[j];
        }
      }
    }

    // No explicit selection. Return null — caller decides default behavior (solo = no reframe).
    return null;
  }

  function tierIsSolo(contract) {
    if (!contract) return true;
    if (contract.minQuantity === 1 && (!contract.gift || !contract.gift.enabled || !contract.gift.products || !contract.gift.products.length)) {
      return true;
    }
    return false;
  }

  function computeQbSavings(qbEntry, mainCents) {
    if (!qbEntry || !mainCents) return null;
    var contract = getSelectedTier(qbEntry.widget, qbEntry.deal);
    if (!contract) return null;
    if (tierIsSolo(contract)) return null;
    if (!contract.gift || !contract.gift.products || !contract.gift.products.length) return null;

    var paidQty = contract.minQuantity || 1;
    var giftQty = 0;
    for (var i = 0; i < contract.gift.products.length; i++) {
      giftQty += contract.gift.products[i].quantity || 0;
    }
    if (giftQty <= 0) return null;

    var totalQty = paidQty + giftQty;
    var bundleFullCents = totalQty * mainCents;
    var savingsCents = giftQty * mainCents;
    var productTitle = (qbEntry.product && qbEntry.product.title) || (contract.name || 'produs');

    return {
      contract: contract,
      paidQty: paidQty,
      giftQty: giftQty,
      totalQty: totalQty,
      bundleFullCents: bundleFullCents,
      savingsCents: savingsCents,
      productTitle: productTitle,
      label: '+ ' + giftQty + ' × ' + (productTitle.split(' ').slice(0, 1).join(' ') || 'cadou') + ' cadou'
    };
  }

  // ============================================================
  // Controller
  // ============================================================

  function Controller() {
    this.widgets = [];
    this.qbWidgets = [];
    this.byProductId = Object.create(null);
    this.priceBlock = null;
    this.moneyFormat = DEFAULT_MONEY_FORMAT;
  }

  Controller.prototype.registerWidget = function (widget) {
    var state = decodeState(widget);
    if (!state) return;
    if (state.options && state.options.moneyFormat) this.moneyFormat = state.options.moneyFormat;

    var rewards = flattenRewards(state);
    var self = this;
    rewards.forEach(function (r) {
      if (r && r.id != null) self.byProductId[String(r.id)] = r;
    });

    var block = findPriceBlock(widget);
    if (!this.priceBlock && block) this.priceBlock = block;

    this.widgets.push(widget);

    var obs = new MutationObserver(function () { self.bindCheckboxes(widget); });
    obs.observe(widget, { childList: true, subtree: true });
    this.bindCheckboxes(widget);

    debug('UPSELL widget registered', { rewards: rewards.length, hasPriceBlock: !!this.priceBlock });
  };

  Controller.prototype.registerQbWidget = function (entry) {
    if (!entry || !entry.widget) return;
    var block = findPriceBlock(entry.widget);
    if (!this.priceBlock && block) this.priceBlock = block;

    this.qbWidgets.push(entry);
    var self = this;

    // MutationObserver — class/aria/selected attribute changes
    var obs = new MutationObserver(function () { self.recompute(); });
    obs.observe(entry.widget, {
      attributes: true,
      attributeFilter: ['class', 'aria-selected', 'data-selected', 'checked'],
      subtree: true,
      childList: true
    });

    debug('QUANTITY_BREAKS widget registered', { blockId: entry.blockId, contracts: entry.deal.definition && entry.deal.definition.contracts ? entry.deal.definition.contracts.length : 0 });
  };

  Controller.prototype.bindCheckboxes = function (widget) {
    var self = this;
    var inputs = widget.querySelectorAll('input[type="checkbox"]');
    var boundAny = false;
    for (var i = 0; i < inputs.length; i++) {
      var cb = inputs[i];
      if (cb.dataset.koalaPriceBound) continue;
      cb.dataset.koalaPriceBound = '1';
      cb.addEventListener('change', function () { self.recompute(); });
      boundAny = true;
    }
    if (boundAny) {
      debug('bound checkboxes', inputs.length);
      self.recompute();
    }
  };

  Controller.prototype.collectCheckedAddons = function () {
    var out = [];
    for (var w = 0; w < this.widgets.length; w++) {
      var inputs = this.widgets[w].querySelectorAll('input[type="checkbox"]');
      for (var i = 0; i < inputs.length; i++) {
        var cb = inputs[i];
        if (!cb.checked || cb.disabled) continue;
        var pid = cb.getAttribute('data-product-id');
        if (!pid) continue;
        var reward = this.byProductId[String(pid)];
        if (!reward) continue;
        var variant = pickAvailableVariant(reward);
        if (!variant) continue;
        out.push({ reward: reward, variant: variant });
      }
    }
    return out;
  };

  Controller.prototype.recompute = function () {
    var block = this.priceBlock || (this.priceBlock = findPriceBlock(this.widgets[0] || (this.qbWidgets[0] && this.qbWidgets[0].widget)));
    if (!block) { debug('no price block, skip recompute'); return; }

    var compareSlot = getOrCreateSlot(block, 'data-koala-compare', 'price__koala-compare');
    var savingsSlot = getOrCreateSlot(block, 'data-koala-savings', 'price__koala-savings');
    var fmt = this.moneyFormat;
    var mainCents = readMainPriceCents(block);

    // Aggregate from UPSELL
    // HONEST math: addon is NOT free in UPSELL, it's discounted.
    // - addonFullSum     = sum of compare_at_price × qty (full retail, for compare/struck slot)
    // - addonDiscountedSum = sum of variant.price × qty (what user actually pays)
    // - savings (UPSELL) = addonFullSum - addonDiscountedSum (the real reducere)
    var addons = this.collectCheckedAddons();
    var addonFullSum = 0;
    var addonDiscountedSum = 0;
    var addonTitles = [];
    if (mainCents && addons.length) {
      for (var i = 0; i < addons.length; i++) {
        var v = addons[i].variant;
        var paid = v.price || 0;
        var full = (v.compare_at_price && v.compare_at_price > 0) ? v.compare_at_price : paid;
        var qty = (v.quantity && v.quantity > 0) ? v.quantity : 1;
        addonFullSum += (full || 0) * qty;
        addonDiscountedSum += paid * qty;
        var t = addons[i].reward.title || '';
        if (t) addonTitles.push(t);
      }
    }
    var addonSavingsCents = Math.max(0, addonFullSum - addonDiscountedSum);

    // Aggregate from QUANTITY_BREAKS
    var qbResults = [];
    var qbSavingsSum = 0;
    var qbLabels = [];
    if (mainCents) {
      for (var q = 0; q < this.qbWidgets.length; q++) {
        var r = computeQbSavings(this.qbWidgets[q], mainCents);
        if (r) {
          qbResults.push(r);
          qbSavingsSum += r.savingsCents;
          qbLabels.push(r.label);
        }
      }
    }

    // UPSELL savings = reducere reală (full − discounted), NU full retail.
    // QB savings = giftQty × mainCents (truly free gifts).
    var totalSavings = addonSavingsCents + qbSavingsSum;
    var hasAny = (addons.length > 0 && addonDiscountedSum > 0) || qbResults.length > 0;

    if (!hasAny || !mainCents) {
      var wasActive = block.classList.contains('price--koala-active');
      hideSlot(compareSlot);
      hideSlot(savingsSlot);
      block.classList.remove('price--koala-active');
      // Revert .price__regular (data-koala-base-price) text when bundle deactivates.
      var baseSpanDeact = block.querySelector('[data-koala-base-price]');
      if (baseSpanDeact && baseSpanDeact.dataset.koalaInjected === '1') {
        baseSpanDeact.textContent = baseSpanDeact.dataset.koalaOrigText || baseSpanDeact.textContent;
        delete baseSpanDeact.dataset.koalaInjected;
        delete baseSpanDeact.dataset.koalaOrigText;
      }
      // Revert qty stepper on bundle deactivate. Stop watchdog.
      try {
        if (window.__koalaQtyWatch) { clearInterval(window.__koalaQtyWatch); window.__koalaQtyWatch = null; }
        var nativeSetter2 = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set;
        var ins2 = document.querySelectorAll(
          'input[name="quantity"], quantity-input input[type="number"], input.quantity__input, [data-quantity-input] input'
        );
        for (var k2 = 0; k2 < ins2.length; k2++) {
          if (ins2[k2].dataset.koalaQtyInjected === '1') {
            nativeSetter2.call(ins2[k2], ins2[k2].dataset.koalaQtyOrig || '1');
            try {
              ins2[k2].dispatchEvent(new Event('input', { bubbles: true }));
              ins2[k2].dispatchEvent(new Event('change', { bubbles: true }));
            } catch (e) {}
            delete ins2[k2].dataset.koalaQtyInjected;
            delete ins2[k2].dataset.koalaQtyOrig;
          }
        }
      } catch (e) {}
      // Revert NUIT theme's #custom-original-price + badge when bundle deactivates.
      // Restore original text + display (handles products with native Shopify discount).
      var themeOrigDeact = document.getElementById('custom-original-price');
      if (themeOrigDeact && themeOrigDeact.dataset.koalaInjected === '1') {
        themeOrigDeact.textContent = themeOrigDeact.dataset.koalaOrigText || '';
        themeOrigDeact.style.display = themeOrigDeact.dataset.koalaOrigDisplay || 'none';
        themeOrigDeact.style.textDecoration = '';
        themeOrigDeact.style.opacity = '';
        delete themeOrigDeact.dataset.koalaInjected;
        delete themeOrigDeact.dataset.koalaOrigText;
        delete themeOrigDeact.dataset.koalaOrigDisplay;
      }
      var themeBadgeDeact = document.getElementById('custom-discount-badge');
      if (themeBadgeDeact && themeBadgeDeact.dataset.koalaInjected === '1') {
        themeBadgeDeact.textContent = themeBadgeDeact.dataset.koalaOrigText || '';
        themeBadgeDeact.style.display = themeBadgeDeact.dataset.koalaOrigDisplay || 'none';
        delete themeBadgeDeact.dataset.koalaInjected;
        delete themeBadgeDeact.dataset.koalaOrigText;
        delete themeBadgeDeact.dataset.koalaOrigDisplay;
      }
      // Hide gift pill when bundle deactivated
      var giftPillDeact = document.querySelector('[data-koala-gift-pill]');
      if (giftPillDeact) giftPillDeact.style.display = 'none';
      // Restore qty input min attribute
      try {
        var qIns = document.querySelectorAll('input[name="quantity"], input.quantity__input');
        for (var qd2 = 0; qd2 < qIns.length; qd2++) {
          if (qIns[qd2].dataset.koalaOrigMin) {
            qIns[qd2].setAttribute('data-min', qIns[qd2].dataset.koalaOrigMin);
            qIns[qd2].setAttribute('min', qIns[qd2].dataset.koalaOrigMin);
            delete qIns[qd2].dataset.koalaOrigMin;
          }
        }
      } catch (e) {}
      if (wasActive) {
        announce(block, 'Bundle dezactivat. Preț revine la ' + formatCents(mainCents, fmt) + '.');
      }
      debug('cleared', { mainCents: mainCents, addons: addons.length, qb: qbResults.length });
      return;
    }

    // Compute bundleFullCents:
    // - UPSELL contributes main + addons
    // - QB contributes (totalQty × mainCents) per tier
    // If both active, base = mainCents and we add addons + qb bundle delta.
    var bundleFullCents;
    if (qbResults.length) {
      // Start with the largest qb bundle (most paid items + gifts)
      bundleFullCents = 0;
      for (var k = 0; k < qbResults.length; k++) {
        if (qbResults[k].bundleFullCents > bundleFullCents) bundleFullCents = qbResults[k].bundleFullCents;
      }
      // Add addon retail value on top
      bundleFullCents += addonFullSum;
    } else {
      bundleFullCents = mainCents + addonFullSum;
    }

    // Compose savings label.
    // UPSELL = "Cu reducere: <titles> (reducere X RON)" — addon is discounted, NOT free.
    // QB     = "Cadou: <giftQty × productTitle> (valoare X RON)" — gift truly free.
    // Mixed  = both pieces concatenated with " · ".
    var savingsValueStr = formatCents(totalSavings, fmt);
    var compareValueStr = formatCents(bundleFullCents, fmt);
    var compareHtml =
      '<span aria-label="Preț complet dacă cumperi separat: ' + escapeHtml(compareValueStr) + '">' +
      '<s aria-hidden="true">' + escapeHtml(compareValueStr) + '</s>' +
      '</span>';

    var savingsPieces = [];
    if (addonTitles.length && addonSavingsCents > 0) {
      var addonSavingsStr = formatCents(addonSavingsCents, fmt);
      savingsPieces.push(
        'Cu reducere: ' + escapeHtml(addonTitles.join(' + ')) +
        ' (reducere ' + escapeHtml(addonSavingsStr) + ')'
      );
    }
    if (qbLabels.length && qbSavingsSum > 0) {
      // Short, scannable format on both desktop + mobile: "+ 1 × Pernă cadou"
      savingsPieces.push(qbLabels.map(escapeHtml).join(' + '));
    }
    var savingsHtml = savingsPieces.join(' · ');

    showSlot(compareSlot, compareHtml);
    showSlot(savingsSlot, savingsHtml);
    block.classList.add('price--koala-active');

    // Update [data-koala-base-price] (.price__regular) to bundle-paid total for BOGO
    // (e.g., 3+2 tier → display "1.311 RON" instead of single variant "437 RON").
    // Skip for UPSELL-only (keep main variant price; addon is on top of page extra).
    if (qbResults.length) {
      var maxPaidCents = 0;
      var maxTotalQty = 0;
      for (var kk = 0; kk < qbResults.length; kk++) {
        var paidCents = (qbResults[kk].paidQty || 0) * mainCents;
        var tq = (qbResults[kk].paidQty || 0) + (qbResults[kk].giftQty || 0);
        if (paidCents > maxPaidCents) maxPaidCents = paidCents;
        if (tq > maxTotalQty) maxTotalQty = tq;
      }
      var baseSpan = block.querySelector('[data-koala-base-price]');
      if (baseSpan && maxPaidCents > 0) {
        if (baseSpan.dataset.koalaInjected !== '1') {
          baseSpan.dataset.koalaOrigText = baseSpan.textContent || '';
        }
        baseSpan.textContent = formatCents(maxPaidCents, fmt);
        baseSpan.dataset.koalaInjected = '1';
      }

      // Reflect bundle quantity on the popup/sticky quantity stepper. Theme's <quantity-input>
      // custom element has a setQuantityBoundries pubsub handler that resets value to min after
      // any change — to defeat it we use a native setter + watchdog interval re-applying for 8s.
      try {
        var nativeSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set;
        var applyQty = function () {
          if (maxTotalQty <= 0) return;
          var ins = document.querySelectorAll(
            'input[name="quantity"], quantity-input input[type="number"], input.quantity__input, [data-quantity-input] input'
          );
          for (var ii = 0; ii < ins.length; ii++) {
            if (Number(ins[ii].value) !== maxTotalQty) {
              try {
                var curMax = ins[ii].getAttribute('max');
                if (curMax && Number(curMax) < maxTotalQty) ins[ii].setAttribute('max', String(maxTotalQty));
                if (ins[ii].dataset.koalaQtyOrig == null) ins[ii].dataset.koalaQtyOrig = ins[ii].value || '1';
              } catch (e) {}
              nativeSetter.call(ins[ii], String(maxTotalQty));
              ins[ii].dataset.koalaQtyInjected = '1';
              try {
                ins[ii].dispatchEvent(new Event('input', { bubbles: true }));
                ins[ii].dispatchEvent(new Event('change', { bubbles: true }));
              } catch (e) {}
            }
          }
        };
        applyQty();
        // Simple watchdog: 24 × 250ms = 6s. Same approach as v3.8 (worked on mobile).
        if (window.__koalaQtyWatch) clearInterval(window.__koalaQtyWatch);
        var ticks = 0;
        // Capture maxTotalQty by value to avoid stale closure across tier changes
        var watchQty = maxTotalQty;
        window.__koalaQtyWatch = setInterval(function () {
          ticks++;
          var b = document.querySelector('[data-koala-price-block].price--koala-active');
          if (!b || ticks > 24) { clearInterval(window.__koalaQtyWatch); window.__koalaQtyWatch = null; return; }
          applyQty();
        }, 250);
      } catch (e) {}
    }

    // ALSO populate NUIT theme's visible "old/new" price UI (the prominent top price).
    // The theme renders #custom-original-price hidden when no Shopify discount; we make it
    // show our bundle-full price + a savings badge so user sees OLD struck through + NEW bold.
    // Save original state on first injection so we can restore it on deactivate
    // (important for products that have a native Shopify compare_at price).
    var themeOrig = document.getElementById('custom-original-price');
    if (themeOrig) {
      if (themeOrig.dataset.koalaInjected !== '1') {
        themeOrig.dataset.koalaOrigText = themeOrig.textContent || '';
        themeOrig.dataset.koalaOrigDisplay = themeOrig.style.display || '';
      }
      themeOrig.textContent = compareValueStr;
      themeOrig.style.display = 'inline-flex';
      themeOrig.style.textDecoration = 'line-through';
      themeOrig.style.opacity = '0.7';
      themeOrig.dataset.koalaInjected = '1';
    }
    var themeBadge = document.getElementById('custom-discount-badge');
    if (themeBadge && totalSavings > 0) {
      if (themeBadge.dataset.koalaInjected !== '1') {
        themeBadge.dataset.koalaOrigText = themeBadge.textContent || '';
        themeBadge.dataset.koalaOrigDisplay = themeBadge.style.display || '';
      }
      // Compact label that signals "gift included" on mobile + desktop
      // Top discount badge: just savings amount (no "Cadou" word — that lives in popup only)
      themeBadge.textContent = '−' + formatCents(totalSavings, fmt);
      themeBadge.style.setProperty('display', 'inline-flex', 'important');
      themeBadge.style.setProperty('visibility', 'visible', 'important');
      themeBadge.style.display = 'inline-flex';
      themeBadge.dataset.koalaInjected = '1';
    }

    // Hide any previously injected gift pill (kept only in popup [data-koala-savings]).
    var existingPill = document.querySelector('[data-koala-gift-pill]');
    if (existingPill) existingPill.style.display = 'none';

    // Patch quantity input min/max so theme's setQuantityBoundries doesn't clamp value back to 1.
    // Set data-min to bundle qty when bundle active — theme reset will use new min (= bundle qty).
    try {
      var maxQbTotal = 0;
      for (var qbi = 0; qbi < qbResults.length; qbi++) {
        var totalQ = (qbResults[qbi].paidQty || 0) + (qbResults[qbi].giftQty || 0);
        if (totalQ > maxQbTotal) maxQbTotal = totalQ;
      }
      if (maxQbTotal > 0) {
        var allQtyInputs = document.querySelectorAll('input[name="quantity"], input.quantity__input');
        for (var aqi = 0; aqi < allQtyInputs.length; aqi++) {
          var qIn = allQtyInputs[aqi];
          if (!qIn.dataset.koalaOrigMin) qIn.dataset.koalaOrigMin = qIn.getAttribute('data-min') || qIn.getAttribute('min') || '1';
          qIn.setAttribute('data-min', String(maxQbTotal));
          qIn.setAttribute('min', String(maxQbTotal));
        }
      }
    } catch (e) {}

    // aria-live announcement — strip HTML for screen readers
    var announceParts = ['Bundle activ.'];
    announceParts.push('Preț complet dacă cumperi separat: ' + compareValueStr + '.');
    if (addonTitles.length && addonSavingsCents > 0) {
      announceParts.push('Reducere addon: ' + addonTitles.join(' + ') + ', economisești ' + formatCents(addonSavingsCents, fmt) + '.');
    }
    if (qbLabels.length && qbSavingsSum > 0) {
      var qbAnn = qbLabels.map(function (l) { return l.replace(/^Cadou:\s*/, ''); }).join(' + ');
      announceParts.push('Cadou inclus: ' + qbAnn + ', valoare ' + formatCents(qbSavingsSum, fmt) + '.');
    }
    announce(block, announceParts.join(' '));

    debug('recompute', {
      mainCents: mainCents,
      addonFullSum: addonFullSum,
      addonDiscountedSum: addonDiscountedSum,
      addonSavingsCents: addonSavingsCents,
      qbSavingsSum: qbSavingsSum,
      bundleFullCents: bundleFullCents,
      totalSavings: totalSavings
    });
  };

  // ============================================================
  // Init
  // ============================================================

  // Monkey-patch theme's <quantity-input> custom element so its setQuantityBoundries pubsub
  // handler doesn't reset value to min when our Koala bundle is active. Patches the prototype
  // once theme.js has registered the custom element.
  function patchQuantityInputCustomEl() {
    try {
      var ctor = window.customElements && window.customElements.get && window.customElements.get('quantity-input');
      if (!ctor || !ctor.prototype) return false;
      if (ctor.prototype.__koalaPatched) return true;
      ctor.prototype.__koalaPatched = true;
      var origSet = ctor.prototype.setQuantityBoundries;
      ctor.prototype.setQuantityBoundries = function (arg) {
        var bundleActive = document.querySelector('[data-koala-price-block].price--koala-active');
        var ret = origSet ? origSet.call(this, arg) : undefined;
        if (bundleActive && this.input) {
          // Force value to bundle qty (read from our patched data-min)
          var dMin = parseInt(this.input.getAttribute('data-min'), 10);
          if (dMin && dMin > 1) {
            try {
              var ns = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set;
              ns.call(this.input, String(dMin));
            } catch (e) {}
          }
        }
        return ret;
      };
      // Also patch onInputChange so it doesn't empty-value-reset
      var origIC = ctor.prototype.onInputChange;
      if (origIC) {
        ctor.prototype.onInputChange = function () {
          var bundleActive = document.querySelector('[data-koala-price-block].price--koala-active');
          if (bundleActive && this.input && this.input.value === '') {
            var dMin2 = parseInt(this.input.getAttribute('data-min'), 10) || 1;
            try {
              var ns2 = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set;
              ns2.call(this.input, String(dMin2));
            } catch (e) {}
            return; // skip validate that may further mutate
          }
          return origIC.call(this);
        };
      }
      debug('quantity-input prototype patched');
      return true;
    } catch (e) {
      warn('patchQuantityInputCustomEl failed', e);
      return false;
    }
  }

  function init() {
    // Always create controller and bind global listeners — Koala widgets mount asynchronously,
    // so they may not be in DOM at DOMContentLoaded. Rescan timer + listeners will pick them up.
    var ctrl = new Controller();
    var upsellWidgets = document.querySelectorAll('koala-gifts-reward-showcase');
    var qbWidgets = discoverQuantityBreaksWidgets();
    for (var i = 0; i < upsellWidgets.length; i++) ctrl.registerWidget(upsellWidgets[i]);
    for (var j = 0; j < qbWidgets.length; j++) ctrl.registerQbWidget(qbWidgets[j]);
    debug('init', { upsell: upsellWidgets.length, qb: qbWidgets.length });

    // Try patching theme's QuantityInput prototype. Retry for 6s in case theme.js loads after us.
    if (!patchQuantityInputCustomEl()) {
      var patchRetries = 0;
      var patchInt = setInterval(function () {
        patchRetries++;
        if (patchQuantityInputCustomEl() || patchRetries > 30) clearInterval(patchInt);
      }, 200);
    }

    // Event delegation for tier selection (clicks + radio)
    document.body.addEventListener('click', function (ev) {
      var t = ev.target;
      if (!t) return;
      // Match closest tier-like element under any QB widget
      var qbHost = t.closest ? t.closest('koala-quantity-breaks-embed') : null;
      if (!qbHost) return;
      var tierLike = t.closest('[data-tier-id], [data-contract-id], input[type="radio"], .koala-deal__tier');
      if (!tierLike) return;
      // Slight defer so the widget's own state-toggle runs first
      setTimeout(function () { ctrl.recompute(); }, 0);
    }, true);

    document.body.addEventListener('change', function (ev) {
      var t = ev.target;
      if (!t || !t.closest) return;
      var qbHost = t.closest('koala-quantity-breaks-embed');
      if (!qbHost) return;
      if (t.matches('input[type="radio"], select, input[type="checkbox"]')) {
        setTimeout(function () { ctrl.recompute(); }, 0);
      }
    }, true);

    document.addEventListener('variant:change', function () { ctrl.recompute(); });
    document.addEventListener('variantChange', function () { ctrl.recompute(); });
    document.addEventListener('on:variant:change', function () { ctrl.recompute(); });

    var block = ctrl.priceBlock || document.querySelector('[data-koala-price-block]');
    if (block) {
      var blockObs = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var m = mutations[i];
          if (m.type === 'attributes' && (m.attributeName === 'data-variant-id' || m.attributeName === 'data-variant-price')) {
            ctrl.recompute();
            return;
          }
        }
      });
      blockObs.observe(block, { attributes: true, attributeFilter: ['data-variant-id', 'data-variant-price'] });

      var swapObs = new MutationObserver(function () {
        var fresh = document.querySelector('[data-koala-price-block]');
        if (fresh && fresh !== ctrl.priceBlock) {
          ctrl.priceBlock = fresh;
          ctrl.recompute();
        }
      });
      var host = block.parentNode || document.body;
      swapObs.observe(host, { childList: true, subtree: true });
    }

    // Re-scan both QB and UPSELL widgets periodically — Koala app mounts widgets async,
    // sometimes after DOMContentLoaded (up to 10s in slow connections).
    var rescans = 0;
    var rescanTimer = setInterval(function () {
      rescans++;
      var added = false;
      // QB rescan
      var fresh = discoverQuantityBreaksWidgets();
      for (var i = 0; i < fresh.length; i++) {
        var known = false;
        for (var j = 0; j < ctrl.qbWidgets.length; j++) {
          if (ctrl.qbWidgets[j].widget === fresh[i].widget) { known = true; break; }
        }
        if (!known) {
          ctrl.registerQbWidget(fresh[i]);
          added = true;
        }
      }
      // UPSELL rescan — widgets array stores raw widget references (not wrapped objects)
      var upsells = document.querySelectorAll('koala-gifts-reward-showcase');
      for (var u = 0; u < upsells.length; u++) {
        var knownU = false;
        for (var w = 0; w < ctrl.widgets.length; w++) {
          if (ctrl.widgets[w] === upsells[u]) { knownU = true; break; }
        }
        if (!knownU) {
          ctrl.registerWidget(upsells[u]);
          added = true;
        }
      }
      if (added) ctrl.recompute();
      if (rescans >= 24) clearInterval(rescanTimer);
    }, 500);

    ctrl.recompute();

    // Auto-preselect "CEL MAI POPULAR" tier so visitors see the OLD/NEW prices immediately
    // without needing to click. The merchant marked their preferred default in Liquid.
    // We only fire ONCE per page load, only if current selection is Solo (no gift),
    // and only on QUANTITY_BREAKS widgets — UPSELL addons stay user-driven (checkbox).
    var autoSelectFired = false;
    function tryAutoSelectPopularTier() {
      if (autoSelectFired) return;
      var widgets = document.querySelectorAll('koala-quantity-breaks-embed');
      for (var w = 0; w < widgets.length; w++) {
        var widget = widgets[w];
        var currentSel = widget.querySelector('input[type="radio"]:checked');
        var currentLi = currentSel ? currentSel.closest('li') : null;
        // Skip if user already on a non-Solo tier
        if (currentLi && !/solo/i.test(currentLi.innerText)) continue;
        // Find the tier with "CEL MAI POPULAR" badge (merchant-flagged default)
        var tiers = widget.querySelectorAll('li[class*="tier-"]');
        var target = null;
        for (var t = 0; t < tiers.length; t++) {
          if (/CEL MAI POPULAR|most popular|popular|recomandat/i.test(tiers[t].innerText)) {
            target = tiers[t];
            break;
          }
        }
        // Fallback: pick the FIRST non-Solo tier (any bonus tier)
        if (!target) {
          for (var t2 = 0; t2 < tiers.length; t2++) {
            if (!/solo/i.test(tiers[t2].innerText)) {
              target = tiers[t2];
              break;
            }
          }
        }
        if (!target) continue;
        var label = target.querySelector('label.koala-deal__tier') || target.querySelector('label');
        if (label) {
          label.click();
          autoSelectFired = true;
          debug('auto-selected popular tier', { tier: target.innerText.slice(0, 40) });
        }
      }
    }
    // Try after Koala mounts (rescan covers async timing)
    // Auto-preselect DISABLED: was forcing 2+1 bundle on page load → risk of customer
    // accidentally adding 3 pillows. Keep Solo as merchant default. Customer must
    // explicitly click 2+1 or 3+2 to opt into bundle.
    // setTimeout(tryAutoSelectPopularTier, 1500);
    // setTimeout(tryAutoSelectPopularTier, 3500);
    // setTimeout(tryAutoSelectPopularTier, 6000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
